import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=45c50b5a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c50b5a')) {
      api.createRecord('45c50b5a', component.options)
    } else {
      api.reload('45c50b5a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=45c50b5a&", function () {
      api.rerender('45c50b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jSnPnaVI85WZ/JS/comp/ImgFallback.vue"
export default component.exports